// src/UserProfileMenu.js
import React, { useState, useEffect, useRef } from 'react';

function UserProfileMenu({ userProfile, onLogout }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null); // Ref for detecting clicks outside the menu

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Effect to add event listener for closing menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      // If the menu is open and the click is outside the menu's referenced element
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    }
    // Bind the event listener only when the menu is open
    if (isMenuOpen) {
       document.addEventListener("mousedown", handleClickOutside);
    } else {
       document.removeEventListener("mousedown", handleClickOutside);
    }
    // Clean up the event listener when the component unmounts or menu closes
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]); // Re-run effect when isMenuOpen changes


  // Should not render if no profile, App.js handles conditional rendering
  if (!userProfile) return null;

  return (
    // Add ref to the outer div to detect outside clicks
    <div className="user-profile-menu" ref={menuRef} style={{ position: 'relative', display: 'inline-block' }}> {/* Basic inline styling for position relative */}
      {/* Profile Picture */}
      <img
        src={userProfile.picture} // Use picture URL from fetched profile
        alt={userProfile.name || 'User profile'} // Use name from profile if available
        // Add basic styling directly or use CSS class 'profile-picture'
        style={{ width: '40px', height: '40px', borderRadius: '50%', cursor: 'pointer', border: '1px solid #ccc' }}
        onClick={toggleMenu} // Toggle menu on click
        referrerPolicy="no-referrer" // Good practice for external profile pics from Google
      />

      {/* Dropdown Menu - Rendered conditionally */}
      {isMenuOpen && (
        // Add basic styling directly or use CSS class 'dropdown-menu'
        <div className="dropdown-menu" style={{ position: 'absolute', top: '100%', right: '0', backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '4px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', padding: '8px 0', minWidth: '160px', zIndex: 1000, marginTop: '5px' }}>
          {/* Optional: Display user info */}
          {userProfile.name && <div style={{ padding: '8px 16px', fontSize: '0.9em', color: '#555' }}>{userProfile.name}</div>}
          {userProfile.email && <div style={{ padding: '8px 16px', fontSize: '0.8em', color: '#777' }}>{userProfile.email}</div>}
          <div style={{ height: '1px', backgroundColor: '#eee', margin: '8px 0' }}></div> {/* Divider */}
          {/* Logout Button */}
          <button
             onClick={() => {
                onLogout(); // Call the logout function passed via props
                setIsMenuOpen(false); // Close menu after clicking
             }}
             // Add basic styling or use CSS class 'menu-logout-button'
             style={{ display: 'block', width: '100%', padding: '8px 16px', textAlign: 'left', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1em', color: '#d9534f', fontWeight: 'bold' }}
           >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default UserProfileMenu;
